<script>  
import {  MethodsTokenZamaniHesaplama,MethodsHeaderAvatar } from "@/state/helpers";
import { notificationMethods } from "@/state/helpers"; 

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | `+this.$config.APPLICATION_TITLE : this.$config.APPLICATION_TITLE;
    },
  },
  mounted() {
   if(this.$cookie.get('ecampsus') != null){ 
   this.TokenZamaniHesaplama()
   }
  // this.HeaderAvatar()
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    ...MethodsTokenZamaniHesaplama,...MethodsHeaderAvatar,
    Get(){  },
    clearNotification: notificationMethods.clear 
  },
};
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
